import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import aa3340b67ba177a4ac63ce064a7953f8fb from "./generated-557f763a-6fa5-4de5-85a1-97f6ff185fce.json";

import a7585ae551df22a343ec9f5ad0663591eb from "./generated-8042d0a8-9c90-4479-ad49-503862c6ac34.json";

import a572ab03387a45d2e921b3fe0ba2f4ef3b from "./generated-93fbf217-c4b1-49e8-a524-6d8ff96e9940.json";

import acfdd484f46f01f7ad4309c5776a99d3bb from "./generated-dd32ed3c-cdef-42b0-b709-267ee275b35c.json";

import a627e5dd6b57b41068adcf6095f925870b from "./generated-d07fcc4d-4cf6-447f-b3d7-30bcf94bdba1.json";

import acb86a02cf8821870548c0d0618bcefedb from "./generated-b501e7fb-d81c-490e-9853-098c944e09fc.json";

import a924400ee815d472c9d8c7e212a2a9521b from "./generated-57c8ed48-a3f8-4e49-9908-693fde03dd16.json";

import ac5e7f9ce58e0132a504e23055ecdd072b from "./generated-a3771028-1522-4ac6-a4e6-324332d02a43.json";

import af238c216a697431b6c1934d4dfdb6139b from "./generated-8416d526-438e-4ab9-98e7-a8c63c274beb.json";

import a0c9ede04a6fc77ca2dc3032692a2929bb from "./generated-3cdd1dd4-fdeb-43c5-89fd-4c6bdbd0df43.json";

import a91fca90e6087f8d629a5538140586e28b from "./generated-c6f7b8ac-288b-499a-b7e2-5699221d90d8.json";

import a9e2e264401ec3afc1e3e0c388fcadd2fb from "./generated-549b511e-d5dd-482f-8e4d-5a862514d322.json";

import a0977493ead8b668a806f57c8addc7edbb from "./generated-09cd4a02-3952-4140-b97a-3769120e3f20.json";

import aa1f723b346fa7f63b9b57933c1331e71b from "./generated-6be1a0fa-b6e0-4e76-a1c0-31f3a998ecdc.json";

import a58b00a47cfd436bfe72ada644b306fc2b from "./generated-f7ac2be0-b68d-4579-89ce-d1ada19a6196.json";

import a714d89176ea6c46a8db861abcb341e27b from "./generated-2f26255c-98d5-4f62-ae92-21a9dfc83283.json";

import a06c7113010e0a10617cfde5629f79a17b from "./generated-98ad5cf2-84af-4c3b-b2a5-d7ffbee91c52.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(aa3340b67ba177a4ac63ce064a7953f8fb);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a7585ae551df22a343ec9f5ad0663591eb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a572ab03387a45d2e921b3fe0ba2f4ef3b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(acfdd484f46f01f7ad4309c5776a99d3bb);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a627e5dd6b57b41068adcf6095f925870b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(acb86a02cf8821870548c0d0618bcefedb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a924400ee815d472c9d8c7e212a2a9521b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(ac5e7f9ce58e0132a504e23055ecdd072b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(af238c216a697431b6c1934d4dfdb6139b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a0c9ede04a6fc77ca2dc3032692a2929bb);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a91fca90e6087f8d629a5538140586e28b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a9e2e264401ec3afc1e3e0c388fcadd2fb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(af238c216a697431b6c1934d4dfdb6139b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a0977493ead8b668a806f57c8addc7edbb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(aa1f723b346fa7f63b9b57933c1331e71b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(af238c216a697431b6c1934d4dfdb6139b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a58b00a47cfd436bfe72ada644b306fc2b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a714d89176ea6c46a8db861abcb341e27b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a06c7113010e0a10617cfde5629f79a17b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a58b00a47cfd436bfe72ada644b306fc2b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */